import { render, staticRenderFns } from "./SearchHistoryDrawer.vue?vue&type=template&id=e8411956&"
import script from "./SearchHistoryDrawer.vue?vue&type=script&lang=ts&"
export * from "./SearchHistoryDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./SearchHistoryDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports